import { isExternal, isEmpty, disableContext } from '../util/helpers'

export default {
  init() {
    // JavaScript to be fired on all pages

    // Define some things we'll use globally
    const body = document.querySelector('body')
    const navToggle = document.querySelector('.toggle--navigation')
    const anchors = [].slice.call(document.querySelectorAll('a'))
    const pTags = [].slice.call(document.querySelectorAll('p'))
    const images = [].slice.call(document.querySelectorAll('body img'))

    // Handle toggling mobile menu
    if (window.matchMedia('(max-width: 1023px)').matches) {
      navToggle.addEventListener('click', () => {
        body.classList.toggle('nav-is-open')
      })
    }

    // Handle external urls
    anchors.forEach(anchor => {
      if (isExternal(anchor)) {
        // Define attributes to set
        const attributes = {
          target: '__blank',
          rel: 'noopener',
        }

        // Set attributes
        Object.keys(attributes).forEach(attribute => {
          anchor.setAttribute(attribute, attributes[attribute])
        })
      }
    })

    // Handle empty p tags
    pTags.forEach(isEmpty)

    // Prevent image downloading
    images.forEach(disableContext)
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js